import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ProductModel } from '@shared/models/data/product-model';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { NavService } from '@shared/services/nav.service';
import { RouteNames } from 'src/app/routing/route-utils';

@Component({
  selector: 'aaos-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {

  // push first links
  navLinks = [
    { path: RouteNames.overview, label: 'Overview', id: 0 },
    { path: RouteNames.roster, label: 'Roster', id: 1 },
    { path: RouteNames.faculty, label: 'Faculty', id: 2}
  ];

  tabIndex;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private navService: NavService,
    private enrollmentService: EnrollmentService) {
    this.router.events.subscribe(path => {
      if (path instanceof NavigationEnd) {
        this.updateTab((path as NavigationEnd).url);
      }
    });
  }

  ngOnInit() {
    this.enrollmentService.getActiveProducts().subscribe(response => {
      let count = 3;

      // push products
      for (const d of response) {
        if (d.shortName.toUpperCase() === 'OITE'.toUpperCase()) {
          this.navLinks.push({ path: RouteNames.oite, label: 'OITE', id: count++ });
        } else if (d.shortName.toUpperCase() === 'ROCK'.toUpperCase()) {
          this.navLinks.push({ path: RouteNames.rock, label: 'ROCK', id: count++ });
        }
      }

      // push last links
      this.navLinks.push({ path: RouteNames.orderSummary, label: 'Order Summary', id: count++ });

      const currentUrl = this.router.url;
      const tabData = this.navLinks.find(x => x.path === currentUrl.replace('/', ''));

      if (tabData) {
        this.tabIndex = tabData.id;
      }
    });
  }

  navigate(event: MatTabChangeEvent) {
    const tabData = this.navLinks[event.index];
    this.navService.goToPath(tabData.path);
  }

  updateTab(url: string) {
    if (url) {
      const tabData = this.navLinks.find(x => x.path === url.substring(1));
      if (tabData && tabData.id) {
        this.tabIndex = tabData.id;
      }
    }



  }

}
